import { types, actions } from './requests'
export const GETTURN_TYPES = {
    ...types('GETTURN'),
}
export const GETTURN_ACTIONS = {
    ...actions('GETTURN'),
}
